// extracted by mini-css-extract-plugin
export default {"dialog":"UGyZ-9lQSSBo2XmEQFBtxw=="};